<template>
    <component :is="tag" class="scc-list" :class="classes">
        <li v-for="(item, i) in items" :key="i">{{ item }}</li>
    </component>
</template>

<script>
import './list.scss';

export default {
    name: 'List',
    __editor: {
        fields: {
            type: {
                widget: 'select',
                values: ['bulleted', 'numbered'],
            },
            bulletStyle: {
                widget: 'select',
                values: ['default', 'primary', 'secondary'],
            },
            indent: {
                widget: 'checkbox',
            },
            whitespace: {
                widget: 'checkbox',
            },
        },
    },
    props: {
        type: {
            type: String,
            default: 'bulleted',
        },
        bulletStyle: {
            type: String,
            default: 'default',
        },
        indent: {
            type: Boolean,
            default: true,
        },
        whitespace: {
            type: Boolean,
            default: false,
        },
        items: {
            type: Array,
            default: () => [],
        },
    },
    computed: {
        tag() {
            return this.type === 'bulleted' ? 'ul' : 'ol';
        },
        classes() {
            let classes = [];
            if (this.type === 'bulleted') classes.push(`scc-list-bullet-style--${this.bulletStyle}`);
            if (!this.indent) classes.push('scc-list--no-indent');
            if (this.whitespace) classes.push('scc-list--whitespace');
            return classes;
        },
    },
};
</script>
